export default class Category {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        categoryRetrieve(id: ${id}) {
          id
          name
          image {
            id
            url
          }
          parent {
            id
            name
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.categoryRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        categoryList {
          results {
            id
            name
            image {
                id
                url
              }
            parent {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.categoryList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteCategory(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteCategory.ok;
  }

  static async create(axios, name, parent, image) {
      const imageField = (image > 0) ? `image: ${image},` : ``;
      const parentField = (parent > 0) ? `parent: ${parent},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createCategory(newCategory: {
          ${imageField}
          ${parentField}
          name: "${name}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createCategory.ok;
  }


  static async edit(axios, id, name, parent, image) {
    const imageField = (image > 0) ? `image: ${image},` : ``;
    const parentField = (parent > 0) ? `parent: ${parent},` : ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateCategory(newCategory: {
          ${imageField}
          ${parentField}
          id: ${id},
          name: "${name}", 
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.updateCategory.ok;
  }


}
